import axios from "axios";
import { path } from "ramda";
import { toast } from "react-toastify";
import ENV from "../_env";

const httpErrorHandlers = {
  401: (error) => {
    toast.error("Login inválido, por favor faça o login novamente");
    setTimeout(() => {
      localStorage.removeItem("@SSPDS_SSAS:token");
      localStorage.removeItem("@SSPDS_SSAS:roles");
      localStorage.removeItem("@SSPDS_SSAS:client");
      window.location.reload(true);
    }, 3000);
  },
};

export const httpErrorHandler = (error, logout) => {
  if (error.response) {
    const { status } = error.response;
    const handler = httpErrorHandlers[`${status}`];

    if (handler) handler(error, logout);
  }
};

const mapResponseToUsefulData = (response) => {
  // console.log("aiox1", response)
  return response;
};

const mapToUsefulError = (error) => {
  // try get from body
  const messageFromBody = path(["response", "data", "message"], error);
  // const messageFromBody = path(['response', 'data'], error);
  if (messageFromBody) return { message: messageFromBody, error };
  // try get exception
  const messageFromError = error && error.message;
  if (messageFromError) return { message: messageFromError, error };
  // otherwise, return error
  return { message: error, error };
};

const api = axios.create({
  //baseURL: "https://spca.sspds.ce.gov.br/prod/api",
  //baseURL: "http://172.25.10.62:8090/",
  //baseURL: 'http://localhost:8090/',
  baseURL: `${ENV.server}`,
  //baseURL: "http://172.25.10.62:8090/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 1000 * 1200,
});

const handleError = (error) => {
  // log
  // eslint-disable-next-line no-console
  console.error(error);
  // handle http erros
  httpErrorHandler(error, api.unsetAuth);
  // extract in useful error format
  const usefulError = mapToUsefulError(error);
  //  publish('error', usefulError);

  return Promise.reject(usefulError);
};

api.interceptors.response.use(
  // data
  (response) => mapResponseToUsefulData(response),
  // error response
  // eslint-disable-next-line comma-dangle
  (error) => handleError(error)
);

// interceptors
api.interceptors.request.use(
  // update config before request
  (config) => config,
  // handle request error
  (error) => handleError(error)
);

export default api;
